import type { LucideIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

interface HomeQuickAction {
  id: string
  label: string
  subtitle: string
  icon: LucideIcon
  to: string
  iconClassName?: string
}

interface HomeQuickActionsProps {
  actions: HomeQuickAction[]
}

export function HomeQuickActions({ actions }: HomeQuickActionsProps) {
  return (
    <div className="home-quick-actions">
      {actions.map(({ id, label, subtitle, icon: Icon, to, iconClassName }) => (
        <Link key={id} to={to} className="home-quick-action-card">
          <div className={`home-quick-action-icon ${iconClassName || ''}`}>
            <Icon className="w-5 h-5" />
          </div>
          <div>
            <p className="font-semibold text-white">{label}</p>
            <p className="text-sm text-gray-400">{subtitle}</p>
          </div>
        </Link>
      ))}
    </div>
  )
}
